import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { getWindowInnerWidth } from 'src_common/common/mobx-utils/Services/window';
import {
    ContentWrapper,
    ContentWrapperChildren,
} from 'src/domains/layouts/webview/modules/layoutSkeleton/LayoutSkeleton.style';
import { RouteViewType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { CollectionType } from 'src/domains/casino/types/types';
import { RightHandSideViewType } from 'src/domains/layouts/state/router/newRouter/rhsRouteType';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { Header, HeaderMainLinks, UnreadCount } from 'src/domains/layouts/webview/modules/layoutSkeleton/Header';
import {
    NavigationSidebar,
    SidebarCloseIconWrapper,
    SidebarSlideIconWrapper,
} from 'src/domains/layouts/webview/modules/layoutSkeleton/NavigationSidebar';
import { MessageBarWrapper } from 'src/domains/layouts/webview/components/MessageBarWrapper';
import { Footer } from './layoutSkeleton/Footer';

export { Header, HeaderMainLinks, SidebarCloseIconWrapper, UnreadCount, SidebarSlideIconWrapper, NavigationSidebar };
interface PropsType {
    navigation?: boolean;
    children: React.ReactChild;
    currentView: RouteViewType;
    isSearchActive: boolean;
    navigationType: CollectionType | 'global';
    accountView: RightHandSideViewType | null;
    streamRmgWrapperIsVisible?: boolean;
    isStreamOpen?: boolean;
    isAccountOpen?: boolean;
}

const renderContent = (
    navigation: boolean,
    children: React.ReactChild,
    currentView: RouteViewType,
    isSearchActive: boolean,
    navigationType: CollectionType | 'global',
    streamRmgWrapperIsVisible: boolean | undefined,
    isStreamOpen: boolean | undefined,
    isAccountOpen: boolean | undefined,
    sportsbookVariant: DefaultComponentVariantType | null,
    isClosing: boolean
): React.ReactNode => {
    if (navigation) {
        return (
            <ContentWrapper>
                {isClosing ? null : (
                    <NavigationSidebar
                        currentView={currentView}
                        isSearchActive={isSearchActive}
                        navigationType={navigationType}
                    />
                )}
                <ContentWrapperChildren
                    variant={sportsbookVariant}
                    streamRmgWrapperIsVisible={streamRmgWrapperIsVisible}
                    isStreamOpen={isStreamOpen}
                    isAccountOpen={isAccountOpen}
                >
                    {children}
                    {sportsbookVariant === DefaultComponentVariantType.SECONDARY && (
                        <Footer currentView={currentView} />
                    )}
                </ContentWrapperChildren>
            </ContentWrapper>
        );
    }

    const widthInner = getWindowInnerWidth();
    const navSidebar =
        widthInner !== null && widthInner < 1200 && isClosing === false ? (
            <NavigationSidebar
                currentView={currentView}
                isSearchActive={isSearchActive}
                navigationType={navigationType}
            />
        ) : null;

    return (
        <>
            {navSidebar}
            {children}
        </>
    );
};

export const LayoutSkeleton = observer('LayoutSkeleton', (props: PropsType) => {
    const {
        navigation,
        children,
        isSearchActive,
        navigationType,
        currentView,
        accountView,
        streamRmgWrapperIsVisible,
        isStreamOpen,
        isAccountOpen,
    } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const { sportsbookVariant } = configState.componentVariants;
    const { closureModeWithLogin, closureMode, midnightMigrationScreen } = configState;
    const isClosing = closureModeWithLogin || closureMode || midnightMigrationScreen;

    return (
        <>
            <Header
                accountView={accountView}
                currentView={currentView}
            />
            <MessageBarWrapper />
            {renderContent(
                navigation ?? true,
                children,
                currentView,
                isSearchActive,
                navigationType,
                streamRmgWrapperIsVisible,
                isStreamOpen,
                isAccountOpen,
                sportsbookVariant,
                isClosing
            )}
        </>
    );
});
